<template>
    <b-modal
        v-model="shown"
        centered
        :title="'Edit' + ' ' + $t('cost.service_charge')"
        lazy
    >
        <div>

            <b-form-group>
                <div><label>{{ $t('cost.service_charge') }}</label></div>
                <b-input-group prepend="%">
                    <b-form-input
                        v-model="serviceCharge"
                        type="number"
                        min="0"
                        step="1"
                    />
                </b-input-group>
            </b-form-group>

        </div>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="handleClose()"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :loading="submitLoading"
                @click="handleSubmit()"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import vueComponentReset from '@ianwalter/vue-component-reset';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    submitLoading: false,
}));

export default {

    mixins: [
        resetMixin,
    ],

    data() {
        return {
            shown: false,
        };
    },

    computed: {
        serviceCharge: {
            get() {
                return this.$store.getters['costable/costable'].service_charge;
            },
            set(value) {
                this.$store.dispatch('costable/setServiceCharge', value);
            },
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openServiceChargeModal, () => {
            this.shown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            try {
                await this.$store.dispatch('costable/updateServiceCharge', this.serviceCharge);
                this.handleClose();
            } catch (e) {
                // Do nothing
            }

            this.submitLoading = false;
        },
        handleClose() {
            this.shown = false;
        },
    },

};
</script>
